import template from './table-responsive.html';

const tableResponsiveComponent = {
  template,
  bindings: {
    data: '<',
    keys: '<'
  }
};

export default tableResponsiveComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/table-responsive/table-responsive.component.js
 **/